import { TestImage } from "@assets/constant/index.constant";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import { usePathname } from "@utils/hook/index.hook";
import React, { useEffect } from "react";
import TeamMemberForm from "./form/index.form";
import { endpoint } from "@services/api.services";
import { format } from "date-fns";
import { QueryData } from "@utils/interface/index.interface";
import { TeamUserData } from "@utils/interface/journey.interface";
import { useMetaStore } from "@utils/states/index.state";
import { useSearchParams } from "react-router";
import { useListData } from "@utils/query/index.query";
import { ColumnList } from "./column/index.column";
import FilterPopover from "@ui/internal/components/filter-popover";
type Props = {};

const index: React.FC<Props> = ({}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  const pathname = usePathname();
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch, error } = useListData<
    QueryData<TeamUserData>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
      user__is_superuser: searchParams.get("user__is_superuser") || "",
      designation__id__in: searchParams.get("designation") || "",
    },
    endpoint: endpoint["team-member"],
    key: `${pathname}-listing`,
    window: true,
  });
  // rollback
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);

  const columns = ColumnList({ refetch });

  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: pathname,
        }}
        form={<TeamMemberForm />}
        showOrientationSecond
        inject_ui_table_actions={
          <>
            <FilterPopover
              filters={[
                {
                  label: "Designation",
                  endpointValue: "designation",
                  format: { key: "name", value: "id" },
                },
                {
                  label: "Is Super Admin",
                  searchKey: "user__is_superuser",
                  radio: true,
                  defaultOptions: [
                    {
                      label: "Yes",
                      value: "true",
                    },

                    {
                      label: "No",
                      value: "false",
                    },
                  ],
                },
              ]}
              title="Filter"
              triggerText="Filter"
            />
          </>
        }
        grid={
          <GeneralCard
            showCheck
            isChecked={false}
            type={"teammember"}
            content={{
              image: TestImage,
              title: "Aayush Maharjan",
              subtitle: "Frontend Developer",
            }}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        endpoint={endpoint["team-member"]}
        columns={columns}
        refetch={refetch}
        isPending={isPending}
        rows={data?.data?.results ?? []}
        sortableFilter={{
          search: search,

          created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
          created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
          ordering: searchParams.get("ordering") || "order",
          user__is_superuser: searchParams.get("user__is_superuser") || "",
          designation__id__in: searchParams.get("designation") || "",
        }}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default index;
